(function (scope) {
  const imageUrl = (product) => {
    const value = typeof product?.featured_image === 'string'
      ? product.featured_image
      : product?.featured_image?.src;
    if (typeof value !== 'string') return null;
    if (value.startsWith('//')) return `https:${value}`;
    return /^https?:\/\//i.test(value) ? value : null;
  };

  const selectCartRecommendations = (products, cart) => {
    const inCart = new Set((cart?.items || []).map((item) => String(item.product_id)));
    return (Array.isArray(products) ? products : [])
      .filter((product) => product?.available && imageUrl(product)
        && typeof product.url === 'string' && product.url.startsWith('/')
        && !product.url.startsWith('//') && !inCart.has(String(product.id)))
      .slice(0, 2);
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = { selectCartRecommendations };
  if (!scope.document) return;

  const document = scope.document;
  let requestNumber = 0;
  const routeRoot = () => scope.Shopify?.routes?.root || '/';
  const formatMoney = (cents, currency) => {
    if (scope.theme?.Currency?.formatMoney) {
      return scope.theme.Currency.formatMoney(cents, scope.theme.settings.moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency || 'USD',
    }).format((Number(cents) || 0) / 100);
  };

  const render = (root, products, cart) => {
    const grid = root.querySelector('[data-wq-cart-recommendations-grid]');
    if (!grid) return;
    grid.replaceChildren();

    selectCartRecommendations(products, cart).forEach((product) => {
      const card = document.createElement('a');
      card.className = 'wq-cart-recommendations__card';
      card.href = product.url;

      const image = document.createElement('img');
      image.src = imageUrl(product);
      image.alt = product.title || '';
      image.loading = 'lazy';
      card.append(image);

      const title = document.createElement('span');
      title.className = 'wq-cart-recommendations__title';
      title.textContent = product.title || '';
      card.append(title);

      const price = document.createElement('span');
      price.className = 'wq-cart-recommendations__price';
      const current = Number(product.price_min ?? product.price);
      const compare = Number(product.compare_at_price_min ?? product.compare_at_price);
      if (Number.isFinite(compare) && compare > current) {
        const oldPrice = document.createElement('s');
        oldPrice.textContent = formatMoney(compare, cart.currency);
        price.append(oldPrice);
      }
      price.append(document.createTextNode(product.price_varies ? `From ${formatMoney(current, cart.currency)}` : formatMoney(current, cart.currency)));
      card.append(price);
      grid.append(card);
    });
    root.hidden = grid.children.length === 0;
  };

  const load = async (providedCart) => {
    const root = document.querySelector('#CartDrawer [data-wq-cart-recommendations]');
    if (!root) return;
    const request = ++requestNumber;
    try {
      const cart = providedCart?.items ? providedCart : await fetch(`${routeRoot()}cart.js`, {
        headers: { Accept: 'application/json' },
      }).then((response) => {
        if (!response.ok) throw new Error(`Cart ${response.status}`);
        return response.json();
      });
      if (request !== requestNumber) return;
      if (!cart.items?.length) { root.hidden = true; return; }

      const productId = cart.items[0].product_id;
      const url = `${routeRoot()}recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=8&intent=related`;
      const data = await fetch(url, { headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error(`Recommendations ${response.status}`);
        return response.json();
      });
      if (request === requestNumber) render(root, data.products, cart);
    } catch (_error) {
      if (request === requestNumber) root.hidden = true;
    }
  };

  document.addEventListener('cart:updated', (event) => load(event.detail?.cart));
  document.addEventListener('cart:build', () => load());
  document.addEventListener('ajaxProduct:added', () => load());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => load(), { once: true });
  else load();
})(typeof window !== 'undefined' ? window : globalThis);
